import { PureComponent } from 'react';
import _capitalize from 'lodash/capitalize';
import classes from './page_description.less';
import classNames from 'classnames';
import Clamp from './clamp';

type Props = {
  size: 'small' | 'large';
  description: string | undefined;
  className?: string;
};

export default class PageDescription extends PureComponent<Props> {
  render() {
    const { description, size, className } = this.props;
    if (!description) {
      return null;
    }
    const suffix = _capitalize(size);

    return (
      <div className={classNames(classes[`navDesc${suffix}`], className)}>
        <Clamp className={classes[`description${suffix}`]} text={description} />
      </div>
    );
  }
}
